import type { Language } from "./types";

const messages = {
  ja: {
    ageEyebrow: "ADULTS ONLY / 18+",
    ageTitle: "18歳以上の方のみ入店できます。",
    ageDescription: "成人向け商品を扱う3Dストアです。\n18歳未満の方は利用できません。",
    enter: "18歳以上です",
    leave: "18歳未満です",
    leaveTitle: "ご利用いただけません",
    leaveBody: "このサイトは18歳以上の方を対象としています。",
    returnToGate: "年齢確認へ戻る",
    opening: "3Dストアを起動中",
    stockingShelves: "本日の棚を入荷中…",
    catalogFallback: "棚の入荷に時間がかかっています",
    preparing: "本日の棚を準備中",
    all: "すべて",
    newShelf: "新着",
    popularShelf: "人気",
    filter: "棚を選ぶ",
    instructions: "ドラッグで見回す  ·  光る区画をタップして歩く  ·  WASD",
    tapProduct: "パッケージをタップ",
    performer: "出演者",
    maker: "メーカー",
    genres: "ジャンル",
    releaseDate: "発売日",
    productCode: "配信品番",
    price: "価格",
    priceNotice: "表示価格は取得時点のものです。最新情報は遷移先でご確認ください。",
    openFanza: "FANZAで作品を見る",
    adLabel: "広告",
    close: "閉じる",
    menu: "メニュー",
    quality: "3D描画品質",
    qualityNote: "高DPI端末の解像度と動作負荷",
    hideFloorGuides: "床ガイドを隠す",
    hideFloorGuidesNote: "床区画とハイライトを非表示",
    resetPosition: "入口へ戻る",
    help: "操作方法",
    about: "クイヤとは",
    aboutBackHome: "ストアへ戻る",
    aboutTitle: "クイヤと、クイ屋について",
    aboutLead: "クイヤは、テレビ番組のなぞなぞ回答から生まれ、ネット上で生態まで語られるようになった架空の動物です。数字の9を嫌い、モルモットやビーバーのような姿をした害獣という“設定”が広がっています。",
    aboutStoreTitle: "当店「クイ屋」",
    aboutStoreBody: "QUIYAは、その不思議な名前とレンタルビデオ店の「屋」を掛けた、歩いて棚を選ぶ3Dビデオショップです。効率だけでは出会えない一本を、看板を見て、通路を歩き、手に取るように探す体験をつくっています。",
    privacyTitle: "プライバシーポリシー",
    privacyIntro: "QUIYAは、サービスの提供・改善と安全な運用に必要な範囲で情報を取り扱います。",
    privacyCollectionTitle: "取得する情報",
    privacyCollection: "言語・画質設定、年齢確認済みの状態を端末内に保存します。また、ホスティング事業者がIPアドレス、ブラウザ情報、閲覧日時などのアクセスログを取得する場合があります。",
    privacyUseTitle: "利用目的",
    privacyUse: "表示設定の維持、障害調査、不正利用の防止、表示品質とサービス内容の改善に利用します。",
    privacyThirdTitle: "外部サービス",
    privacyThird: "作品情報と画像の取得、作品ページへの遷移、サイト配信のためにDMM/FANZAおよびCloudflare等の外部サービスを利用します。遷移後は各サービスのプライバシーポリシーが適用されます。",
    privacyContactTitle: "お問い合わせ",
    privacyContact: "本方針に関するお問い合わせ：",
    privacyUpdated: "制定日：2026年8月20日",
    helpTitle: "店内の歩き方",
    helpBody: "画面をドラッグすると、店内を見回せます。PCではWASDも使えます。\nモバイルでは左下のスティックを進みたい方向へ動かします。\nハイライトされた床をタップしても移動できます。\nケースはドラッグして表・背・裏を確認できます。",
    mobileMove: "移動スティック",
    understood: "OK",
    loadingImage: "パッケージを読込中",
    noImage: "画像を表示できません",
    rotateCase: "ドラッグしてケースを回転",
    caseViewer: "回転できる3Dレンタルビデオケース",
    sourceSeed: "指定商品で展示中",
    sourceApi: "本日のFANZA動画",
    webglUnavailable: "この端末では3D表示を開始できませんでした。",
    aboutTermsLink: "利用規約はこちら",
    creditTitle: "クレジット表記",
    creditNote: "本サイトはDMM Webサービス（FANZA）のAPIを利用して作成されています。",
    termsTitle: "利用規約",
    termsUpdated: "制定日：2026年8月20日",
    termsIntro: "本規約は、QUIYA（クイ屋）の利用条件を定めるものです。本サイトを利用することで、本規約に同意したものとみなします。",
    termsAgeTitle: "年齢制限",
    termsAgeBody: "本サイトは成人向け商品を取り扱うため、18歳以上の方のみ利用できます。18歳未満の方の利用はできません。",
    termsAffiliateTitle: "アフィリエイト広告について",
    termsAffiliateBody: "当サイトはアフィリエイト広告を利用しています。商品リンクを経由してFANZA（DMM）で購入された場合、当サイトが報酬を受け取ることがあります。広告であることは各画面・商品ボタン・本ページ等で明示しています。",
    termsContentTitle: "商品情報の正確性と遷移先",
    termsContentBody: "商品情報（タイトル、価格、画像、出演者等）はDMM WebサービスAPIから取得した取得時点のものです。最新の情報・在庫・価格・内容は、遷移先のFANZAにてご確認ください。購入・契約はすべてFANZA（DMM）との間で行われ、当サイトでは決済を行いません。",
    termsIpTitle: "知的財産権",
    termsIpBody: "商品画像・タイトル等の権利は各権利者に帰属します。QUIYAの名称・ロゴ・暖簾・店舗デザインの権利は運営に帰属します。DMM/FANZAの商標・ロゴの利用は各ガイドラインに従います。",
    termsImageUse: "元画像ファイルを加工・再生成せず、同一画像の各領域を3Dケースの表・背・裏へ割り当てています。",
    termsDisclaimerTitle: "免責事項",
    termsDisclaimerBody: "本サイトは現状有姿で提供され、動作・表示・商品データの完全性を保証するものではありません。リンク先（FANZA等）におけるトラブルや損害について、当サイトは一切の責任を負いません。",
    termsProhibitedTitle: "禁止事項",
    termsProhibitedBody: "法令違反、他者の権利侵害、不正アクセス、スクレイピング、過度な負荷を与える行為等は禁止します。",
    termsGoverningTitle: "準拠法・管轄",
    termsGoverningBody: "本規約は日本法に準拠し、本サイトに関する紛争は、日本の法令に従い管轄権を有する裁判所を管轄裁判所とします。",
    termsChangesTitle: "規約の変更",
    termsChangesBody: "当サイトは必要に応じて本規約を変更することがあります。変更後の規約は本ページに掲載された時点で効力を生じます。",
    termsPrivacyLink: "プライバシーポリシーはこちら",
  },
  en: {
    ageEyebrow: "ADULTS ONLY / 18+",
    ageTitle: "Only visitors aged 18 or older may pass this curtain.",
    ageDescription: "This is a 3D store for adult products.\nVisitors under 18 may not use it.",
    enter: "I am 18 or older",
    leave: "I am under 18",
    leaveTitle: "You cannot enter",
    leaveBody: "This website is intended only for adults aged 18 or older.",
    returnToGate: "Return to age check",
    opening: "Starting the 3D store",
    stockingShelves: "Stocking today's shelves…",
    catalogFallback: "The shelves are taking longer to stock",
    preparing: "Stocking today's shelves",
    all: "All",
    newShelf: "New",
    popularShelf: "Popular",
    filter: "Choose a shelf",
    instructions: "Drag to look  ·  tap a highlighted zone to walk  ·  WASD",
    tapProduct: "Tap a package",
    performer: "Performer",
    maker: "Maker",
    genres: "Genres",
    releaseDate: "Release date",
    productCode: "Distribution ID",
    price: "Price",
    priceNotice: "Prices reflect the retrieval time. Check the destination for the latest information.",
    openFanza: "View this title on FANZA",
    adLabel: "Ad",
    close: "Close",
    menu: "Menu",
    quality: "3D render quality",
    qualityNote: "Resolution and load on high-DPI devices",
    hideFloorGuides: "Hide floor guides",
    hideFloorGuidesNote: "Hide floor zones and highlights",
    resetPosition: "Back to entrance",
    help: "Controls",
    about: "About QUIYA",
    aboutBackHome: "Back to store",
    aboutTitle: "About Kuiya and the Kui-ya Store",
    aboutLead: "Kuiya is a fictional animal born from an answer to a TV riddle, later given an entire imaginary ecology online. Internet lore describes it as a guinea-pig- or beaver-like pest that dislikes the number nine.",
    aboutStoreTitle: "Our “Kui-ya” store",
    aboutStoreBody: "QUIYA pairs that curious name with ya, the Japanese word for a shop. It is a walkable 3D video store where you read hanging signs, explore aisles, and discover a title as if taking a case from a real shelf—embracing a little useful inconvenience.",
    privacyTitle: "Privacy Policy",
    privacyIntro: "QUIYA handles information only as needed to provide, improve, and operate the service safely.",
    privacyCollectionTitle: "Information we handle",
    privacyCollection: "Language, display quality, and age-gate status are stored on your device. Our hosting provider may also process access logs such as IP address, browser information, and access time.",
    privacyUseTitle: "How information is used",
    privacyUse: "We use it to preserve display settings, diagnose failures, prevent abuse, and improve the service and rendering quality.",
    privacyThirdTitle: "External services",
    privacyThird: "DMM/FANZA and providers such as Cloudflare are used to retrieve title data and images, open title pages, and deliver the site. Their privacy policies apply after you visit their services.",
    privacyContactTitle: "Contact",
    privacyContact: "Questions about this policy: ",
    privacyUpdated: "Effective: August 20, 2026",
    helpTitle: "How to walk the store",
    helpBody: "Drag to look around the store; on desktop, WASD also works.\nOn mobile, move the lower-left stick in the direction you want to walk.\nYou can also move by tapping a highlighted floor zone.\nDrag a case to inspect its front, spine, and back.",
    mobileMove: "Movement stick",
    understood: "OK",
    loadingImage: "Loading package",
    noImage: "Image unavailable",
    rotateCase: "Drag to rotate the case",
    caseViewer: "Rotatable 3D rental video case",
    sourceSeed: "Showing the reference title",
    sourceApi: "Today's FANZA videos",
    webglUnavailable: "3D view could not start on this device.",
    aboutTermsLink: "Terms of Service",
    creditTitle: "Credit",
    creditNote: "This site is built using the DMM Web Service (FANZA) API.",
    termsTitle: "Terms of Service",
    termsUpdated: "Effective: August 20, 2026",
    termsIntro: "These terms govern your use of QUIYA (Kui-ya). By using this site, you agree to these terms.",
    termsAgeTitle: "Age restriction",
    termsAgeBody: "This site handles adult products and is available only to visitors aged 18 or older. Minors may not use this site.",
    termsAffiliateTitle: "About affiliate advertising",
    termsAffiliateBody: "This site uses affiliate advertising. If you purchase through a product link on FANZA (DMM), we may receive a reward. We clearly disclose that this is advertising on each screen, the product button, and this page.",
    termsContentTitle: "Accuracy of product information and outbound links",
    termsContentBody: "Product information (title, price, images, performers, etc.) is retrieved from the DMM Web Service API and reflects the time of retrieval. For the latest information, stock, pricing, and content, please check FANZA, the destination site. All purchases and contracts are made directly with FANZA (DMM); this site does not process payments.",
    termsIpTitle: "Intellectual property",
    termsIpBody: "Rights to product images, titles, and similar belong to their respective owners. Rights to the QUIYA name, logo, noren, and store design belong to the operator. Use of DMM/FANZA trademarks and logos follows the applicable guidelines.",
    termsImageUse: "Original image files are not edited or regenerated; regions of the same image are assigned to the front, spine, and back of the 3D case.",
    termsDisclaimerTitle: "Disclaimer",
    termsDisclaimerBody: "This site is provided \"as is\" without warranty of operation, display, or completeness of product data. We are not liable for any trouble or damage on linked sites such as FANZA.",
    termsProhibitedTitle: "Prohibited conduct",
    termsProhibitedBody: "Violation of laws, infringement of others' rights, unauthorized access, scraping, and actions that impose excessive load are prohibited.",
    termsGoverningTitle: "Governing law and jurisdiction",
    termsGoverningBody: "These terms are governed by Japanese law. Any dispute relating to this site is subject to a court having jurisdiction under Japanese law.",
    termsChangesTitle: "Changes to the terms",
    termsChangesBody: "We may change these terms as needed. Revised terms take effect when posted on this page.",
    termsPrivacyLink: "Privacy Policy",
  },
} as const;

export type MessageKey = keyof (typeof messages)["ja"];

export function t(language: Language, key: MessageKey): string {
  return messages[language][key];
}
